import { render, staticRenderFns } from "./IssueCenterArticle.vue?vue&type=template&id=7d27c199&"
import script from "./IssueCenterArticle.vue?vue&type=script&lang=js&"
export * from "./IssueCenterArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports